import moment from "moment";
import axios from "axios";
import Cookie from "universal-cookie";
import { toggleAuthStatus } from "./external/actions";
import { toaster } from "evergreen-ui";
import validator from "validator";
import { saveAs } from "file-saver";

// Cookies -------------------------------------------------------------------------------------------------------------

export const setCookies = (data) => {
  const cookies = new Cookie();
  cookies.set("authToken", data["authToken"], { maxAge: 5256000 });
  cookies.set("clubName", data["clubName"], { maxAge: 5256000 });
  cookies.set("username", data["username"], { maxAge: 5256000 });
  cookies.set("clubId", data["clubId"], { maxAge: 5256000 });
  cookies.set("userClubs", JSON.stringify(data["userClubs"]), {
    maxAge: 5256000,
  });
  cookies.set("currency", data["clubCurrency"], { maxAge: 5256000 });
  cookies.set("countryCode", data["countryCode"], { maxAge: 5256000 });
};

export const getCookie = (key, path = "/") => {
  const cookies = new Cookie();
  return cookies.get(key, { path });
};

export const deleteCookies = () => {
  const cookies = new Cookie();
  cookies.remove("authToken", { path: "/" });
  cookies.remove("clubName", { path: "/" });
  cookies.remove("username", { path: "/" });
  cookies.remove("clubId", { path: "/" });
  cookies.remove("userClubs", { path: "/" });
  cookies.remove("currency", { path: "/" });
  cookies.remove("countryCode", { path: "/" });
};

export const getCurrency = () => {
  return getCookie("currency");
};

export const clearLocalStorage = () => {
  localStorage.clear();
};

// DateTime ------------------------------------------------------------------------------------------------------------

export const getCurrentDate = (format = "ddd, Do MMM YY") => {
  return moment().format(format);
};

export const getCurrentTime = (format = "h:mm a") => {
  return moment().format(format);
};

export const getFormattedTime = (
  timeString,
  inputFormat = "HH:mm:ss",
  outputFormat = "hh:mm a"
) => {
  return moment(timeString, inputFormat).format(outputFormat);
};

export const getFormattedDate = (
  dateString,
  inputFormat = "ddd, Do MMM YY",
  outputFormat = "YYYY-MM-DD"
) => {
  return moment(dateString, inputFormat).format(outputFormat);
};

export const checkPastTime = (
  timeString,
  inputFormat = "ddd, Do MMM YY HH:mm:ss"
) => {
  return moment(timeString, inputFormat).isBefore();
};

export const getPreviousDay = (
  date,
  inputFormat = "ddd, Do MMM YY",
  outputFormat = "ddd, Do MMM YY"
) => {
  return moment(date, inputFormat).subtract(1, "day").format(outputFormat);
};

export const getNextDay = (
  date,
  inputFormat = "ddd, Do MMM YY",
  outputFormat = "ddd, Do MMM YY"
) => {
  return moment(date, inputFormat).add(1, "day").format(outputFormat);
};

export const getDateObject = (dateString, format = "YYYY-MM-DD") => {
  return moment(dateString, format);
};

export const getTimeObject = (timeString, format = "HH:mm:ss") => {
  return moment(timeString, format);
};

export const getMomentTimeObj1 = (time) => {
  return moment(time, "h:mm a").toDate();
};

export const getFormattedTime24 = (timeString) => {
  return moment(timeString, ["h:mm A"]).format("HH:mm:ss");
};

export const disabledDate = (current) => {
  return (
    moment().add(0, "days") <= current || moment().add(1, "month") <= current
  );
};

export const checkIfDateIsAfter = (date1, date2) => {
  return date1.isAfter(date2);
};

export const checkIfDateIsBefore = (date1, date2) => {
  return date1.isBefore(date2);
};

export const checkIfTimeIsAfter = (time1, time2) => {
  return time1.isAfter(time2);
};

export const checkIfTimeIsBefore = (time1, time2) => {
  return time1.isBefore(time2);
};

export const timeAddition = (timeA, timeB) => {
  const timeObjectA = getTimeObject(timeA);
  const timeObjectB = getTimeObject(timeB);
  return timeObjectA
    .add(timeObjectB.hours(), "hours")
    .add(timeObjectB.minutes(), "minutes")
    .add(timeObjectB.seconds(), "seconds")
    .format("YYYY-MM-DD HH:mm:ss");
};

// Requests ------------------------------------------------------------------------------------------------------------

export const getConfig = (
  params = Object(),
  responseType = "application/json"
) => {
  return Object.assign(Object(), {
    headers: Object.assign(Object(), {
      "Content-Type": "application/json",
      Authorization: getCookie("authToken"),

      // "User-Agent": "Partner-App"
    }),
    params,
    responseType,
  });
};

export const errorHandler = async (dispatch, err) => {
  if (err.response.status === 401 || err.response.status === 403) {
    deleteCookies();
    dispatch(toggleAuthStatus());
    toaster.notify("Please login again", {
      id: "403",
    });
  } else if (err.response.status === 404) {
    toaster.danger("Please try again later", {
      id: "404",
      description: "Some resources could not load",
    });
  } else {
    toaster.danger("Something went wrong", {
      id: "error",
      description: "Please contact Playo",
    });
  }
};

export const responseHandler = async (dispatch, res, reducerType) => {
  if (res.status === 200) {
    if (res.data.requestStatus === -1) {
      toaster.warning("you dont have permission");
      await dispatch({ type: reducerType, data: res.data });
    } else {
      await dispatch({ type: reducerType, data: res.data });
    }
  }
};

export const toQueryString = (paramsObject) => {
  return Object.keys(paramsObject)
    .map(
      (key) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(paramsObject[key])}`
    )
    .join("&");
};

export const downloadResponseHandler = (res, fileName, errorMessage) => {
  if (
    res.headers["content-type"] === "application/vnd.openxmlformats" ||
    res.headers["content-type"] === "application/pdf"
  ) {
    let apiUrl = res.request.responseURL;
    let auth = res.config.headers.Authorization;
    let current_time = moment().format("hh:mm:ss");
    let name = `${current_time}-${fileName}`;
    console.log({ apiUrl, auth, current_time, name });
    let url = `https://alpha.playo.club/download?URL=${apiUrl}&auth=${auth}&name=${name}`;
    // const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();

    //     // // window.open(
    //     // //   `https://alpha.playo.club/download?URL=${apiUrl}&auth=${auth}&name=${name}`
    //     // // )
  } else if (
    res.headers["content-type"] === "application/json; charset=utf-8" &&
    res.headers["content-length"] === "42"
  ) {
    toaster.warning("you dont have permission");
  } else {
    toaster.warning(errorMessage, { id: "download" });
  }
};
export const getRequest = (url, config) => {
  return axios.get(url, config);
};

export const postRequest = (url, body, config) => {
  return axios.post(url, body, config);
};

// Carting -------------------------------------------------------------------------------------------------------------

export const getCartDetails = () => {
  const cart = localStorage.getItem("cart") || "{}";
  return JSON.parse(cart);
};

export const checkCartedSlot = (date, slot, cart) => {
  const slots = cart["slots"] || [];
  for (let i = 0; i < slots.length; i++) {
    const cartedSlot = slots[i].slot;
    if (
      cartedSlot.slotDate === getFormattedDate(date) &&
      cartedSlot.activityId === slot.activityId &&
      cartedSlot.slotTime === slot.startTime
    ) {
      return true;
    }
  }
  return false;
};

const getSortedSlots = (slots) => {
  slots = slots.sort((a, b) => {
    const dateCheck =
      getDateObject(a["slotDate"]) - getDateObject(b["slotDate"]);
    if (dateCheck !== 0) {
      return dateCheck;
    }
    return getTimeObject(a["slotTime"]) - getTimeObject(b["slotTime"]);
  });
  slots.forEach((slot, index) => {
    slot.index = index;
  });
  return slots;
};

export const getCommonCourts = (slots) => {
  const courtSets = slots.map((item) => {
    const slot = item["slot"];
    return slot.courts.reduce((accumulator, court) => {
      accumulator.push(court);
      return accumulator;
    }, []);
  });
  return Array.from(
    courtSets.reduce((a, b) => {
      const courIds = b.reduce((accumulator, court) => {
        accumulator.add(court.courtId);
        return accumulator;
      }, new Set());
      return new Set([...a].filter((x) => courIds.has(x["courtId"])));
    })
  );
};

const checkContinuousSlot = (slots) => {
  let previousSlot = null;
  for (let i = 0; i < slots.length; i++) {
    const slot = slots[i].slot;
    if (previousSlot) {
      if (
        previousSlot.slotDate !== slot.slotDate ||
        previousSlot.endTime !== slot.slotTime
      ) {
        return false;
      }
    }
    previousSlot = slot;
  }
  return true;
};

export const getSlotId = (data) => {
  return (
    getFormattedDate(data["date"]) +
    data["slot"].activityId.toString() +
    (data["slot"].startTime || data["slot"]["slotTime"])
  );
};

export const addToCart = (data, isBulkBooking) => {
  let cart = getCartDetails();

  const slot = data["slot"];
  const slots = (cart["slots"] && [...cart["slots"]]) || [];
  slots.push({
    slotDuration: slot.slotDuration,
    slotId: data.slotId,

    slot: {
      ...slot,
      courts: slot.available,
      slotDate: getFormattedDate(data.date),
      slotTime: slot.startTime || slot.slotTime,
    },
  });
  if (!isBulkBooking) {
    const sortedSlots = getSortedSlots(slots);
    const isContinuous = checkContinuousSlot(sortedSlots);
    cart.showPaymentLink = slot.showPaymentLink;
    if (isContinuous) {
      if (!getCommonCourts(slots).length) {
        toaster.warning("The same courts are unavailable", {
          id: "continuous-slots",
        });
      } else {
        cart.slots = slots;
        localStorage.setItem("cart", JSON.stringify(cart));
      }
    } else {
      toaster.warning("Please select continuous slots", {
        id: "continuous-slots",
      });
    }
  } else {
    cart.isBulkBooking = isBulkBooking;
    cart.slots = slots;
    localStorage.setItem("cart", JSON.stringify(cart));
  }
  return cart;
};

export const removeFromCart = (slotId) => {
  const cart = getCartDetails();
  let slots = cart["slots"];
  const slot = slots.find(
    (slot, index) =>
      slot["slotId"] === slotId && [0, slots.length - 1].includes(index)
  );
  if (slot) {
    cart["slots"] = slots.filter((slot) => slot["slotId"] !== slotId);
    localStorage.setItem("cart", JSON.stringify(cart));
  }
  return cart;
};

const getDiscountedSlot = (slot) => {
  slot.clubDiscount = slot.clubDiscount || 0;
  slot.credits = slot.credits || 0;
  slot.grossPrice = slot.price;
  let isEdited = slot.isEdited;
  if (Object.keys(slot["slotDiscount"]).length) {
    let discount = Number();
    Object.keys(slot["slotDiscount"]).forEach((count) => {
      if (slot.slotCount % parseInt(count) === 0) {
        discount = parseFloat(slot["slotDiscount"][count]);
      }
    });
    if (discount && !isEdited) {
      slot.grossPrice = slot.price - (slot.price * discount) / 100;
    }
  }
  return slot;
};

const getSlotsGrossAndNetPrice = (cart) => {
  let slotsGrossPrice = Number();
  let slotsNetPrice = Number();
  cart.slots.forEach((item) => {
    slotsGrossPrice += item["slot"].grossPrice;
    slotsNetPrice +=
      item["slot"].grossPrice -
      item["slot"].clubDiscount -
      item["slot"].credits;
  });
  return { slotsGrossPrice, slotsNetPrice };
};

export const getCartPrice = (cart) => {
  const { slotsGrossPrice, slotsNetPrice } = getSlotsGrossAndNetPrice(cart);
  Object.assign(cart, {
    slotsGrossPrice,
    slotsNetPrice,
    cartPrice: slotsGrossPrice,
  });

  return cart;
};

export const getCartSummaryAndPrice = (cart) => {
  let date;
  let activityName;
  cart.slots = cart.slots.map((item, index) => {
    date = getFormattedDate(
      item["slot"].slotDate,
      "YYYY-MM-DD",
      "ddd, Do MMM YY"
    );
    activityName = item["slot"].activityName;
    item["slot"].slotCount = index + 1;
    item["slot"] = getDiscountedSlot(item["slot"]);
    return item;
  });
  cart = getCartPrice(cart);
  const slots =
    getFormattedTime(cart.slots[0].slot.slotTime) +
    " - " +
    getFormattedTime(cart.slots[cart.slots.length - 1].slot.endTime);
  return {
    date,
    activityName,
    slots,
    price: cart.slotsNetPrice,
    showPaymentLink: cart.showPaymentLink,
  };
};

export const clearCart = () => {
  const cart = Object();
  localStorage.setItem("cart", JSON.stringify(cart));
  return cart;
};

export const editCartAmount = (cart, cartPrice) => {
  const slotPrice = cartPrice / cart.slots.length;

  cart.slots.forEach((item) => {
    item["slot"].price = slotPrice;
    item["slot"]["isEdited"] = true;
  });

  cart = getCartPrice(cart);
  return cart;
};

// Edit Price---------------------------------------------------------------------------------------------------------------------

export const modifyPriceSlots = async (priceSlots) => {
  let modifiedPriceSlots = JSON.parse(JSON.stringify(priceSlots));

  await modifiedPriceSlots.priceSlots.forEach((slot) => {
    if (slot.slotDiscount === null) {
      slot.slotDiscount = [["", ""]];
    } else if (isObjEmpty(slot.slotDiscount)) {
      slot.slotDiscount = [["", ""]];
    } else {
      slot.slotDiscount = Object.entries(slot.slotDiscount);
    }
    slot.isInvalid = false;
  });

  return modifiedPriceSlots;
};

export const isObjEmpty = (obj) => {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
};

// -----------------------------------------------------------------------
// validate Percentage
// -----------------------------------------------------------------------
export const validatePercentage = (num) => {
  if (
    (validator.isInt(num) || validator.isFloat(num)) &&
    num > 0 &&
    num <= 100 &&
    num.toString().charAt(0) !== "+" &&
    num.toString().charAt(3) !== "."
  ) {
    return "set";
  } else if (num.toString().charAt(0) === "0" && num.length === 1) {
    return "clear";
  } else if (num.toString().charAt(0) === "." && num.length === 1) {
    return "clear";
  } else if (num.length === 0) {
    return "clear";
  }
};

// -----------------------------------------------------------------------
// Validate if number is int and not float and greater than equal to 0
// -----------------------------------------------------------------------
export const validateNumber2 = (num) => {
  if (
    num.length > 0 &&
    num >= 0 &&
    validator.isInt(num) &&
    !validator.contains(num, ".") &&
    !validator.contains(num, "+")
  ) {
    return "set";
  } else if (num.length === 1 && num.charAt(0) === 0) {
    return "clear";
  } else if (num.length <= 0) {
    return "clear";
  }
};

// -----------------------------------------------------------------------
// Validate Credits and Price
// -----------------------------------------------------------------------
export const validateCreditsAndPrice = (price) => {
  if (
    (validator.isInt(price) || validator.isFloat(price)) &&
    price >= 0 &&
    price.toString().charAt(0) !== "+"
  ) {
    return "set";
  } else if (price.toString().charAt(0) === "0" && price.length === 1) {
    return "clear";
  } else if (price.toString().charAt(0) === "." && price.length === 1) {
    return "clear";
  } else if (price.length === 0) {
    return "clear";
  }
};

// -----Check for empty hourly price  -----//

export const isHourlyPrice = async (priceSlots) => {
  let isInvalid = false;

  let modifiedPriceSlots = JSON.parse(JSON.stringify(priceSlots));

  await modifiedPriceSlots.priceSlots.forEach((slot) => {
    if (slot.pricingAmount === "") {
      isInvalid = true;
    }
  });

  return isInvalid;
};

export const formatNumberAsCurrency = (currency, number) => {
  return number.toLocaleString("en-US", {
    style: "currency",
    currency: currency,
  });
};

export const checkIntOrFloat = (num) => {
  return Number.isInteger(num)
    ? Number(parseInt(num))
    : Number(parseFloat(num).toFixed(2));
};

export const createObjects = (data) => {
  // Create an array of objects
  const objectsArray = [];

  // Create an array of keys based on the input object
  const keys = Object.keys(data);

  // Split the input data into arrays based on the keys
  const keyArrays = {};

  keys.forEach((key) => {
    keyArrays[key] = data[key].split(", ");
  });

  // Find the maximum length among the arrays
  const maxLength = Math.max(...keys.map((key) => keyArrays[key].length));

  // Create objects by iterating over the arrays
  for (let i = 0; i < maxLength; i++) {
    const obj = {};
    keys.forEach((key) => {
      obj[key] = keyArrays[key][i] || ""; // Handle cases where there's no value
    });
    objectsArray.push(obj);
  }

  return objectsArray;
};
